import React, { useEffect, useMemo } from "react";
import "./SchedulerFilters.scss";
import { useAllActiveOffices } from "repositories/scheduler-repository";
import constants from "../../../../../constants";

function OfficeFilter({
  setOfficeFilter,
  selectedOffice = [],
  selectedOwnerId,
  includeOwnerOffices = false,
  allElement = () => null,
  setOfficeListShow,
  extraOffices = [],
}) {
  const { data } = useAllActiveOffices(
    1,
    constants.OFFICE_PAGE_SIZE_100,
    {
      includeOwnerOffices: includeOwnerOffices,
      ownerId: selectedOwnerId,
    },
    "",
    { enabled: !!selectedOwnerId },
  );
  const handleChange = (e, item) => {
    const offices = [...selectedOffice];

    const oIndex = offices.findIndex((v) => +item.id === +v);
    if (e.target.checked) {
      offices.push(item.id);
    } else {
      if (oIndex > -1) offices.splice(oIndex, 1);
    }
    setOfficeFilter(offices);
  };
  const officeList = useMemo(() => {
    if (extraOffices?.length > 0) {
      return extraOffices;
    }
    return data?.data || [];
  }, [data?.data, extraOffices]);
  useEffect(() => {
    if (setOfficeListShow && data?.data?.length) {
      setOfficeListShow([...data?.data]);
    }
  }, [data?.data]);
  return (
    <ul className={["filter-list"]}>
      {allElement(officeList)}
      {officeList.map((item, key) => (
        <li key={key}>
          <div className="ch-checkbox">
            <label>
              <input
                type="checkbox"
                onChange={(e) => handleChange(e, item)}
                checked={selectedOffice?.includes(item.id)}
              />{" "}
              <span> {item.name}</span>
            </label>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default OfficeFilter;
